// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const MyRefinement = zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['queued', 'running', 'succeeded'])
});

export type MyRefinement = zod.input<typeof MyRefinement>;
export type MyRefinementOutput = zod.output<typeof MyRefinement>;
